export default {
      id: "yandex-navigator-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "app/svg/sprite.svg#yandex-navigator",
      toString: function () {
        return this.url;
      }
    }